<template>
  <div>
    <v-toolbar color="background darken-1" flat>
      <v-toolbar-title v-bind:class="moveTitleClassObject">
        {{ title }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text dark mediun color="secondary" @click="loadData()">
        <v-icon dark>mdi-refresh</v-icon>
        Actualizar
      </v-btn>
      <excell
        :items="dataTableItems"
        :headers="xlsxHeaders"
        :fieldValues="xlsxFields"
      ></excell>

      <template v-slot:extension>
        <v-tabs
          align-with-title
          v-model="tab"
          slider-color="transparent"
          active-class="background base"
        >
          <v-tab href="#tab-1">
            <v-badge
              inline
              :content="dataTableItems.length"
              :value="dataTableItems.length"
              color="primary"
              transition="scale-transition"
            >
              Mis Cpc´s
            </v-badge>
          </v-tab>

          <v-tab href="#tab-2">
            <v-badge
              inline
              :content="dataTableItemsOtros.length"
              :value="dataTableItemsOtros.length"
              color="primary"
              transition="scale-transition"
            >
              Otros Cpc´s
            </v-badge>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-container fluid grid-list-lg>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-row>
            <v-col no-gutters>
              <resume :isLoading="loading" :agg="agg"></resume>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-tabs v-model="tab2" fixed-tabs>
                <v-tab href="#tab-1">
                  <v-badge
                    inline
                    :content="dataTableItems.length"
                    :value="dataTableItems.length"
                    color="primary"
                    transition="scale-transition"
                  >
                    Gráfico
                  </v-badge>
                </v-tab>
                <v-tab href="#tab-2">
                  <v-badge
                    inline
                    :content="dataTableItems.length"
                    :value="dataTableItems.length"
                    color="primary"
                    transition="scale-transition"
                  >
                    Datos
                  </v-badge>
                </v-tab>

                <v-tab-item value="tab-1">
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-alert
                          v-if="dataTableItems.length > maxChartItems"
                          prominent
                          border="left"
                          color="error"
                          type="error"
                          transition="scale-transition"
                        >
                          <v-row align="center">
                            <v-col class="grow">
                              El modo
                              <span class="body-2 font-weight-bold"
                                >GRÁFICO</span
                              >
                              solo le permite visualizar hasta
                              {{ maxChartItems }} registros de los
                              {{ dataTableItems.length | currency("", 0) }}
                              encontrados. Para ver los datos completos haga
                              clic en
                              <span class="body-2 font-weight-bold"
                                >VER DATOS</span
                              >
                            </v-col>
                            <v-col class="shrink">
                              <v-btn color="secondary" @click="verDatos"
                                >VER DATOS</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-row>
                    <v-col>
                      <horizontal-bar-chart
                        v-bind:style="{ height: chartHeight + 55 + 'px' }"
                        :datos="chartData"
                        :yAxisLabelTruncateLength="yAxisLabelTruncateLength"
                        :yAxisLabelTruncateSeparator="
                          yAxisLabelTruncateSeparator
                        "
                        :filterValue="filterValue"
                      ></horizontal-bar-chart>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item value="tab-2" class="my-4">
                  <v-data-table
                    :calculate-widths="true"
                    dense
                    :items="dataTableItems"
                    :headers="headers"
                    class="elevation-0"
                    style="font-size:10px"
                    :loading="loading"
                    loading-text="Cargando... Por favor espere"
                    :mobile-breakpoint="100"
                    :footer-props="{
                      'items-per-page-options': [25, 50, 100]
                    }"
                    :top-props="{
                      'items-per-page-options': [25, 50, 100]
                    }"
                    @update:pagination="updatePagination"
                  >
                    <!--       <template v-slot:top="{ items }">
              <v-data-footer></v-data-footer>
            </template> -->
                    <template v-slot:item.presupuesto_2019="{ item }">
                      {{ item.presupuesto_2019 | currency }}
                    </template>
                    <template v-slot:item.ejecutado_2019="{ item }">
                      {{ item.ejecutado_2019 | currency }}
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item value="tab-2">
          <v-row>
            <v-col no-gutters>
              <resume :isLoading="loading" :agg="aggOtros"></resume>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-tabs v-model="tab2" fixed-tabs>
                <v-tab href="#tab-1">
                  <v-badge
                    inline
                    :content="dataTableItemsOtros.length"
                    :value="dataTableItemsOtros.length"
                    color="primary"
                    transition="scale-transition"
                  >
                    Gráfico
                  </v-badge>
                </v-tab>
                <v-tab href="#tab-2">
                  <v-badge
                    inline
                    :content="dataTableItemsOtros.length"
                    :value="dataTableItemsOtros.length"
                    color="primary"
                    transition="scale-transition"
                  >
                    Datos
                  </v-badge>
                </v-tab>

                <v-tab-item value="tab-1">
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-alert
                          v-if="dataTableItemsOtros.length > maxChartItems"
                          prominent
                          border="left"
                          color="error"
                          type="error"
                          transition="scale-transition"
                        >
                          <v-row align="center">
                            <v-col class="grow">
                              El modo
                              <span class="body-2 font-weight-bold"
                                >GRÁFICO</span
                              >
                              solo le permite visualizar hasta
                              {{ maxChartItems }} registros de los
                              {{ dataTableItemsOtros.length | currency("", 0) }}
                              encontrados. Para ver los datos completos haga
                              clic en
                              <span class="body-2 font-weight-bold"
                                >VER DATOS</span
                              >
                            </v-col>
                            <v-col class="shrink">
                              <v-btn color="secondary" @click="verDatos"
                                >VER DATOS</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-row>
                    <v-col>
                      <horizontal-bar-chart
                        v-bind:style="{ height: chartHeightOtros + 55 + 'px' }"
                        :datos="chartDataOtros"
                        :yAxisLabelTruncateLength="yAxisLabelTruncateLength"
                        :yAxisLabelTruncateSeparator="
                          yAxisLabelTruncateSeparator
                        "
                        :filterValue="filterValue"
                      ></horizontal-bar-chart>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item value="tab-2" class="my-4">
                  <v-data-table
                    :calculate-widths="true"
                    dense
                    :items="dataTableItemsOtros"
                    :headers="headers"
                    class="elevation-0"
                    style="font-size:10px"
                    :loading="loading"
                    loading-text="Cargando... Por favor espere"
                    :mobile-breakpoint="100"
                    :footer-props="{
                      'items-per-page-options': [25, 50, 100]
                    }"
                    :top-props="{
                      'items-per-page-options': [25, 50, 100]
                    }"
                    @update:pagination="updatePagination"
                  >
                    <!--       <template v-slot:top="{ items }">
              <v-data-footer></v-data-footer>
            </template> -->
                    <template v-slot:item.presupuesto_2019="{ item }">
                      {{ item.presupuesto_2019 | currency }}
                    </template>
                    <template v-slot:item.ejecutado_2019="{ item }">
                      {{ item.ejecutado_2019 | currency }}
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
  <!-- 
  <v-container fluid grid-list-lg>
    <v-row class="px-3">

    </v-row>
  </v-container> -->
</template>

<script>
import { mapGetters } from "vuex";
import { postDashboard } from "@/api/private/dashboard";
import Excell from "@/components/Excell";
import unzipHeadersAndRows from "@/services/elastic/response/jsonUtils";
import HorizontalBarChart from "@/components/charts/HorizontalBarChart.js";
import Resume from "@/components/Resume";
import merge from "lodash/merge";
import keyBy from "lodash/keyBy";
import values from "lodash/values";
export default {
  name: "Aggregations",
  props: {
    title: String,
    filterValue: String,
    yAxisLabelTruncateLength: {
      type: Number,
      default: 0
    },
    yAxisLabelTruncateSeparator: {
      type: String,
      default: " [...]"
    }
  },
  components: {
    Excell,
    HorizontalBarChart,
    Resume
  },
  data() {
    return {
      agg: [],
      aggOtros: [],
      aggregations: {
        byIndex: {
          doc_count_error_upper_bound: 0,
          sum_other_doc_count: 0,
          buckets: [
            {
              key: "pacreport_ec_2019_presupuestado",
              doc_count: 88564,
              total: {
                value: 1145553646.5873268
              },
              byYear: {
                doc_count_error_upper_bound: 0,
                sum_other_doc_count: 0,
                buckets: [
                  {
                    key: "2021",
                    doc_count: 49814,
                    stats: {
                      value: 728632252.7621084
                    }
                  },
                  {
                    key: "2022",
                    doc_count: 38750,
                    stats: {
                      value: 416921393.8252184
                    }
                  }
                ]
              }
            },
            {
              key: "pacreport_ec_2019_ejecutado",
              doc_count: 35298,
              total: {
                value: 494283638.2957842
              },
              byYear: {
                doc_count_error_upper_bound: 0,
                sum_other_doc_count: 0,
                buckets: [
                  {
                    key: "2021",
                    doc_count: 35258,
                    stats: {
                      value: 493591028.8457777
                    }
                  },
                  {
                    key: "2022",
                    doc_count: 40,
                    stats: {
                      value: 692609.450006485
                    }
                  }
                ]
              }
            }
          ]
        }
      },
      maxChartItems: 200,
      tab: null,
      tab2: null,
      dataTableItems: [],
      dataTableItemsOtros: [],
      dataTableItemsEjecutado: [],
      dataTableItemsEjecutadoOtros: [],
      toggle_exclusive: undefined,
      loading: false,
      dialog: false,
      xlsxHeaders: ["DESCRIPCIÓN", "PRESUPUESTADO", "EJECUTADO"],
      xlsxFields: ["label", "presupuesto_2019", "ejecutado_2019"],
      headers: [
        { text: "DESCRIPCIÓN", value: "label" },
        { text: "PRESUPUESTADO", value: "presupuesto_2019", align: "right" },
        { text: "EJECUTADO", value: "ejecutado_2019", align: "right" }
      ],
      logger: {}
    };
  },
  computed: {
    ...mapGetters([
      "filters"
      // ...
    ]),
    chartData: function() {
      return this.dataTableItems.slice(0, this.maxChartItems);
    },
    chartDataOtros: function() {
      return this.dataTableItemsOtros.slice(0, this.maxChartItems);
    },
    drawer() {
      return !this.$store.getters.dashboardDrawer;
    },
    moveTitleClassObject: function() {
      return {
        "ml-12": !this.$store.getters.dashboardDrawer
      };
    },
    chartHeight: function() {
      //return this.dataTableItems.length * 45 + 60;
      return this.chartData.length * 72 + 50;
    },
    chartHeightOtros: function() {
      //return this.dataTableItems.length * 45 + 60;
      return this.chartDataOtros.length * 72 + 50;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.loadData();
      }
    }
  },
  methods: {
    mergeByKey: function(arr1, arr2) {
      let start = 0;
      let merge = [];

      while (start < arr1.length) {
        if (
          arr1[start][`"${this.filterValue}"`] ===
          arr2[start][`"${this.filterValue}"`]
        ) {
          //pushing the merged objects into array
          merge.push({ ...arr1[start], ...arr2[start] });
        }
        //incrementing start value
        start = start + 1;
      }
      return merge;
    },
    loadData: async function() {
      console.log("Loading data..");
      this.dataTableItems = [];
      this.dataTableItemsOtros = [];
      this.loading = true;
      try {
        let {
          agg,
          aggOtros,
          dataTableItems,
          dataTableItemsEjecutado,
          dataTableItemsOtros,
          dataTableItemsEjecutadoOtros
        } = await postDashboard();
        //({ cursor } = dataTableItems);
        this.agg = agg;
        this.aggOtros = aggOtros ? aggOtros : [];

        this.dataTableItems = dataTableItems
          ? unzipHeadersAndRows(dataTableItems)
          : [];
        this.dataTableItemsEjecutado = dataTableItems
          ? unzipHeadersAndRows(dataTableItemsEjecutado)
          : [];

        this.dataTableItemsOtros = dataTableItemsOtros
          ? unzipHeadersAndRows(dataTableItemsOtros)
          : [];
        this.dataTableItemsEjecutadoOtros = dataTableItemsOtros
          ? unzipHeadersAndRows(dataTableItemsEjecutadoOtros)
          : [];

        this.dataTableItems = values(
          merge(
            keyBy(this.dataTableItems, "label"),
            keyBy(this.dataTableItemsEjecutado, "label")
          )
        );

        this.dataTableItemsOtros = values(
          merge(
            keyBy(this.dataTableItemsOtros, "label"),
            keyBy(this.dataTableItemsEjecutadoOtros, "label")
          )
        );
        //console.log(items);
        //console.log(this.dataTableItems);

        /* this.dataTableItems = this.mergeByKey(
          this.dataTableItems,
          this.dataTableItemsEjecutado
        ); */
      } catch (e) {
        console.log(e);
        //this.setError(e);
      } finally {
        this.loading = false;
      }
    },
    verDatos: function() {
      this.tab2 = "tab-2";
    },
    updatePagination: function(pagination) {
      console.log("update:pagination", pagination);
    }
  },
  mounted() {
    this.loadData();
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
